import { MenuItem } from './menu.model';

// Grouped by domain (not scattered): a top Platform group for cross-event/admin
// surfaces, then per-event sections. Every id is unique (duplicate ids break
// MetisMenu active-state tracking). Labels 'Statistics' / 'AI Usage' are matched
// by the sidebar's super-admin gate — do not rename them without updating it.
export const MENU: MenuItem[] = [
    // ── Platform (cross-event / admin) ──────────────────────────────
    { id: 100, label: 'Platform', isTitle: true },
    {
        id: 101,
        label: 'App Version',
        icon: 'bx-mobile',
        link: '/platform/app-config'
    },
    {
        id: 104,
        label: 'Users',
        icon: 'bx-group',
        link: '/platform/users'
    },
    {
        id: 105,
        label: 'Search Usage',
        icon: 'bx-search-alt',
        link: '/platform/search-usage'
    },
    {
        id: 102,
        label: 'MENUITEMS.EVENTS.LIST.TEXT',
        icon: 'bx-calendar',
        link: '/'
    },
    {
        id: 103,
        label: 'Preview Console',
        icon: 'bx-time',
        link: '/preview-console'
    },

    // ── Overview ────────────────────────────────────────────────────
    { id: 110, label: 'Overview', isTitle: true },
    {
        id: 111,
        label: 'Home',
        icon: 'bx-home',
        link: '/events/view',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── Programme ───────────────────────────────────────────────────
    { id: 120, label: 'Programme', isTitle: true },
    {
        id: 121,
        label: 'Sessions',
        icon: 'bx-layer',
        link: '/events/sessions',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 122,
        label: 'Contributions',
        icon: 'bx-chalkboard',
        link: '/events/contributions',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 123,
        label: 'Submitted papers',
        icon: 'bx-file',
        link: '/events/papers',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 124,
        label: 'Awards',
        icon: 'bx-trophy',
        link: '/events/awards',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 125,
        label: 'Programme Changes',
        icon: 'bx-history',
        link: '/events/changes',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── People ──────────────────────────────────────────────────────
    { id: 130, label: 'People', isTitle: true },
    {
        id: 132,
        label: 'Committees',
        icon: 'bx-briefcase-alt',
        link: '/events/committees',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 133,
        label: 'Admins & Moderators',
        icon: 'bx-shield-quarter',
        link: '/events/grants',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── Engagement ──────────────────────────────────────────────────
    { id: 140, label: 'Engagement', isTitle: true },
    {
        id: 141,
        label: 'Q&A',
        icon: 'bx-question-mark',
        link: '/events/qna',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 142,
        label: 'Discussions',
        icon: 'bx-comment-dots',
        link: '/events/discussions',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 143,
        label: 'Participants',
        icon: 'bx-user',
        link: '/events/participants',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── Partners ────────────────────────────────────────────────────
    { id: 150, label: 'Partners', isTitle: true },
    {
        id: 151,
        label: 'Sponsors',
        icon: 'bx-rocket',
        link: '/events/sponsors',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 152,
        label: 'Exhibitors',
        icon: 'bx-store',
        link: '/events/booths',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── Venue & Info ────────────────────────────────────────────────
    { id: 160, label: 'Venue & Info', isTitle: true },
    {
        id: 161,
        label: 'Floor Maps',
        icon: 'bx-map-alt',
        link: '/events/floormaps',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 162,
        label: 'Venue & nearby',
        icon: 'bx-map-pin',
        link: '/events/pois',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 163,
        label: 'Conference Services',
        icon: 'bx-help-circle',
        link: '/events/services',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 164,
        label: 'Information cards',
        icon: 'bx-info-circle',
        link: '/events/info-cards',
        queryParamKey: 'eventId',
        useEventId: true
    },

    // ── Insights ────────────────────────────────────────────────────
    { id: 170, label: 'Insights', isTitle: true },
    {
        id: 171,
        label: 'Statistics',
        icon: 'bx-stats',
        link: '/events/statistics',
        queryParamKey: 'eventId',
        useEventId: true
    },
    {
        id: 172,
        label: 'Analytics',
        icon: 'bx-bar-chart-alt-2',
        link: '/events/analytics',
        queryParamKey: 'eventId',
        useEventId: true,
        feature: 'analytics'
    },
    {
        id: 174,
        label: 'Sponsor ROI',
        icon: 'bx-trophy',
        link: '/events/sponsor-roi',
        queryParamKey: 'eventId',
        useEventId: true,
        feature: 'sponsorRoi'
    },
    {
        id: 175,
        label: 'Post-event report',
        icon: 'bx-file',
        link: '/events/organizer-report',
        queryParamKey: 'eventId',
        useEventId: true,
        feature: 'postEventReport'
    },
    {
        id: 173,
        label: 'AI Usage',
        icon: 'bx-bot',
        link: '/events/ai-usage',
        queryParamKey: 'eventId',
        useEventId: true,
        feature: 'aiUsage'
    },
    {
        id: 176,
        label: 'AI Help Desk sources',
        icon: 'bx-book-content',
        link: '/events/knowledge-sources',
        queryParamKey: 'eventId',
        useEventId: true,
        feature: 'aiSources'
    }
];
